/** Types for the Procurement Products Allergens/Ingredients/Nutritional Info/Dietary Attributes tabs.
 * Ingredients remain UI-only for now (no backend persistence yet). */

import type { ItemAllergen, ItemNutrition, ItemDietaryAttribute } from '../../../app/services/api/orderManagementClient';

export type ProductAllergenEntry = ItemAllergen;

export enum AllergenStatus {
  Contains = 'CONTAINS',
  MayContain = 'MAY_CONTAIN',
  NotPresent = 'NOT_PRESENT',
  FreeFrom = 'FREE_FROM',
  Unknown = 'UNKNOWN',
}

export type ProductNutrientEntry = ItemNutrition;

export enum ValueQualifier {
  Exact = 'EXACT',
  Approximate = 'APPROXIMATE',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  Trace = 'TRACE',
  NotDetected = 'NOT_DETECTED',
  Unknown = 'UNKNOWN',
}

export type ProductDietaryAttributeEntry = ItemDietaryAttribute;

export interface ProductIngredient {
  id: number;
  name: string;
  percentage?: number;
  sortOrder: number;
}

export const emptyAllergenRow = (): ProductAllergenEntry => ({
  allergenCode: '',
  allergenName: '',
  allergenStatus: AllergenStatus.Unknown,
});

export const emptyNutrientRow = (): ProductNutrientEntry => ({
  nutrientCode: '',
  nutrientName: '',
  nutrientValue: undefined,
  valueUom: '',
});

export const emptyDietaryAttributeRow = (): ProductDietaryAttributeEntry => ({
  dietaryAttributeCode: '',
  dietaryAttributeName: '',
  dietaryAttributeStatus: '',
});

